import { MenuT } from 'types/frontend/Menu';

// 나중에 다국어 함수로 대체
const t = (str: string) => str;

const homeworkMenuRootPath = '/teacherSide/homework';

const homeworkAndScheduleMenu: MenuT = [
  {
    title: t('내준 숙제'),
    items: [
      {
        title: t('나의 모든 숙제'),
        path: `${homeworkMenuRootPath}/list`,
      },
      {
        title: t('숙제 검색'),
        path: `${homeworkMenuRootPath}/search`,
      },
    ],
  },
  {
    title: t('숙제 설정'),
    items: [
      {
        title: t('자주 쓰는 숙제'),
        path: `${homeworkMenuRootPath}/preset/add`,
        accessablePositions: ['director', 'assistantDirector'],
      },
    ],
  },
];

export { homeworkAndScheduleMenu };
